
































































































































































import { Vue, Component, PropSync, Watch, Ref } from 'vue-property-decorator'
import ReadAndAccept from '../ReadAndAccept'
import InGameNameRegistration from '@/modules/tournament/components/InGameNameRegistration'
import TournamentRegistration from './TournamentRegistration'
import EnterInvitationCode from '../EnterInvitationCode'
import TeamRegistration from './TeamRegistration'
import TeamRegistrationComplete from './TeamRegistrationComplete'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import TeamRegistrationStatus from '@/modules/tournament/components/TournamentActionDialog/TeamRegistrationStatus/TeamRegistrationStatus.vue'
import ServerError from '@/utils/server_error'
import { TournamentAPI } from '@/api/tournament'
import { TokenAcceptPayload } from '../EnterInvitationCode/EnterInvitationCode.vue'
import TeamJoinDetailReview from './TeamJoinDetailReview'
import TournamentCustomForm from '../TournamentCustomForm'
import { parseSchema } from '@/utils/customform_validation'

enum CreateTeamActions {
  ActionSelection = 1,
  ReadAndAccept = 2,
  IGN = 3,
  CustomForm = 3.5,
  TeamDetailReview = 4,
  Completed = 5
}

enum JoinTeamActions {
  ActionSelection = 1,
  ReadAndAccept = 2,
  EnterInvitationCode = 3,
  IGN = 4,
  CustomForm = 4.5,
  TeamDetailReview = 5,
  Completed = 6
}

enum ActionType {
  Create = 'create',
  Join = 'join'
}

@Component({
  components: {
    TeamRegistrationStatus,
    EnterInvitationCode,
    ReadAndAccept,
    InGameNameRegistration,
    TournamentRegistration,
    TeamRegistration,
    TeamRegistrationComplete,
    TeamJoinDetailReview,
    TournamentCustomForm
  }
})
export default class TournamentActionDialog extends Vue {
  tournamentModule = getModule(tournamentStore, this.$store)
  step: number = 1
  steps: number[] = Array.from(new Array(5), (_, index) => index + 1)
  action: 'create' | 'join' | null = null
  teamToken: string | null = null
  isJoiningTeamWithToken: boolean = false
  selectedTokenTeam: TokenAcceptPayload | null = null
  selectedGroup: string | null = null

  // this is for refreshing data
  seed: number = 0

  // custom form
  schema: any = {}
  formResponse: any = null

  /* Reference elements */
  @Ref('gameAccountRegistration')
  readonly gameAccountRegistration!: InGameNameRegistration

  @Ref('readAndAccept')
  readonly readAndAccept!: ReadAndAccept

  @Ref('enterInvitationCode')
  readonly enterInvitationCode!: EnterInvitationCode

  @Ref('teamRegistration')
  readonly teamRegistration!: TeamRegistration

  @Ref('status')
  readonly registrationStatus!: TeamRegistrationStatus

  get CreateTeamActions() {
    return CreateTeamActions
  }

  /* Watchers */
  @Watch('isVisible')
  onDialogVisiblityChanged(visible: boolean) {
    if (visible) {
      this.seed++
      this.fetchTournamentCustomFormSchema()

      // navigate to status page (5), or home page otherwise.
      this.step = this.hasJoinedTournament ? 5 : 1

      // solo tournament
      if (!this.hasJoinedTournament && this.isSoloTournament) {
        this.action = 'create'
        this.step = 2
      }
    } else {
      setTimeout(() => {
        this.step = 1
        this.action = null
        this.teamToken = null
        this.selectedTokenTeam = null
        this.isJoiningTeamWithToken = false
        this.schema = {}
        this.formResponse = null
        this.selectedGroup = null
      }, 200)

      if (this.gameAccountRegistration) {
        this.gameAccountRegistration.reset()
      }

      if (this.readAndAccept) {
        this.readAndAccept.reset()
      }

      if (this.enterInvitationCode) {
        this.enterInvitationCode.reset()
      }

      if (this.teamRegistration) {
        this.teamRegistration.reset()
      }
    }
  }

  /* Methods */
  setIsVisible(isVisible: boolean = false) {
    this.tournamentModule.setTournamentActionDialogVisible(isVisible)
  }

  back() {
    if (this.step === 3.5 || this.step === 4.5) {
      this.step = this.step - 0.5
    } else {
      this.step--
    }

    if (this.step <= 1 && this.isSoloTournament) {
      this.step = 2
      this.action = 'create'
    }

    if (this.step < 1) {
      this.step = 1
    }

    if (this.enterInvitationCode) {
      this.enterInvitationCode.reset()
    }
  }

  onTournamentTeamCreated(teamToken: string) {
    // this.teamToken = teamToken.substring(0, 3) + ' ' + teamToken.substring(3)
    this.teamToken = teamToken
    this.step = 5

    if (this.schemaLength) {
      this.submitTournamentFormResponse(teamToken)
    }

    // bypass invite code for solo tournament
    if (this.tournament && this.tournament.capacityMaxPlayersPerTeam === 1) {
      this.onJoinTournament()
    }
  }

  onIGNCompleted() {
    // if (this.action === 'create' && this.isSoloTournament) {
    //   this.step = this.schemaLength ? 3.5 : 5
    //   return
    // }

    if (this.action === 'create') {
      this.step = this.schemaLength ? 3.5 : 4
    } else {
      this.step = this.schemaLength ? 4.5 : 5
    }
  }

  onTournamentRegistrationNext(group: string | null) {
    this.selectedGroup = group
    this.step = 2
  }

  async fetchTournamentCustomFormSchema() {
    let response = await TournamentAPI.getTournamentCustomFormSchema(
      this.tournament!.tournamentId
    )
    if (response.data.payload) {
      try {
        this.schema = parseSchema(response.data.payload.schema)
      } catch {
        this.schema = {}
      }
    }
  }

  get hasCustomForm() {
    return Object.keys(this.schema).length > 0
  }

  async submitTournamentFormResponse(token: string) {
    try {
      const response = await TournamentAPI.submitTournamentFormResponseWithToken(
        token,
        JSON.stringify(this.formResponse)
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  async onJoinTournament() {
    // 5 and 6 are competion step for create and join team sequence
    this.step = this.action === 'join' ? 6 : 5
    await this.fetchJoinedTournamentTeam()

    // auto-confirm roster on solo tournament
    if (this.tournament && this.tournament.capacityMaxPlayersPerTeam === 1) {
      setTimeout(() => {
        this.registrationStatus.confirmRoster()
      }, 1000)
    }
  }

  async fetchJoinedTournamentTeam() {
    try {
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.tournament!.tournamentId
      )
    } catch (err) {
      if (err instanceof ServerError) {
        if (err.getStatusCode() >= 400 && err.getStatusCode() < 500) {
          return
        }

        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
        console.error(err)
      }

      await this.$router.push('/')
    }
  }

  async onAcceptTeamToken(payload: TokenAcceptPayload) {
    this.selectedTokenTeam = payload
    this.step = 4
  }

  async confirmTeamJoin() {
    if (!this.selectedTokenTeam || !this.selectedTokenTeam.token) return
    this.isJoiningTeamWithToken = true
    try {
      await TournamentAPI.joinTournamentTeamByTeamToken(
        this.selectedTokenTeam.token
      )
      await this.onJoinTournament()

      if (this.schemaLength) {
        await this.submitTournamentFormResponse(this.selectedTokenTeam.token)
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.isJoiningTeamWithToken = false
    }
  }

  async submitFormResponse(value: any) {
    this.formResponse = value

    // Navigate to finishing step
    this.step = this.action === 'create' ? 4 : 5
  }

  /* Computed Properties */

  get tournament() {
    return this.tournamentModule.selectedTournament
  }

  get schemaLength() {
    return Object.keys(this.schema).length
  }

  get showBackButton() {
    if (this.hasJoinedTournament) {
      return false
    }

    if (this.isSoloTournament && this.step === 2) return false

    return this.step > 1 && this.step < 5
  }

  get hasJoinedTournament() {
    return !!this.tournamentModule.selectedTournamentTeam
  }

  get isSoloTournament() {
    return this.tournament && this.tournament.capacityMaxPlayersPerTeam === 1
  }

  get hideLFG() {
    if (!this.tournament) return false

    if (this.tournament.isAutomated) return true

    if (this.tournament.capacityMaxPlayersPerTeam === 1) return true

    return false
  }

  get isVisible() {
    return this.tournamentModule.tournamentActionDialogVisible
  }
}
